// Module
var code = "<div *ngIf=\"!showLoader\"> <router-outlet></router-outlet> </div> <div *ngIf=\"showLoader\"> <ndd-page-reload></ndd-page-reload> </div> ";
// Exports
module.exports = code;